module.exports = __webpack_public_path__ + "static/media/security-ssl.f92a3654.png";